import {inject, Injectable} from '@angular/core';
import {AdvertisementPackagesModalApiService} from "./advertisement-packages-modal-api.service";
import {RecordData, RecordsDataRequestQueryParams, RecordTotalData} from "../../../../types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class AdvertisementPackagesModalService {
  private advertisementPackagesModalApiService: AdvertisementPackagesModalApiService = inject(AdvertisementPackagesModalApiService);

  public getPackages(queryParams: RecordsDataRequestQueryParams): Promise<Array<RecordData>> {
    return new Promise<Array<RecordData>>((resolve, reject) => {
      this.advertisementPackagesModalApiService.getPackages(queryParams).subscribe({
        next: (recordsData: Array<RecordData>) => resolve(recordsData),
        error: (error) => reject(error)
      })
    })
  }

  public getRecordsData(id: number): Promise<Array<RecordData>> {
    return new Promise<Array<RecordData>>((resolve, reject) => {
      this.advertisementPackagesModalApiService.getRecordsData(id).subscribe({
        next: (recordsData: Array<RecordData>) => resolve(recordsData),
        error: (error) => reject(error)
      });
    });
  }

  public createPackage(packageName: string): Promise<RecordData> {
    return new Promise((resolve, reject) => {
      this.advertisementPackagesModalApiService.createPackages(packageName).subscribe({
        next: (recordData) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getAggregations(id: number): Promise<Array<RecordTotalData>> {
    return new Promise<Array<RecordTotalData>>((resolve, reject) => {
      this.advertisementPackagesModalApiService.getAggregations(id).subscribe({
        next: (aggregations: Array<RecordTotalData>) => resolve(aggregations),
        error: (error) => reject(error)
      });
    });
  }
}
